import React from 'react';

import NotificationShow from '@components/shared/notifications/NotificationShow';

import { notificationService } from '@services/operator/notificationService';

/**
 * Operator 通知詳情頁面
 */
export default function OperatorNotificationShow() {
  return (
    <NotificationShow
      service={notificationService}
      role="operator"
    />
  );
}
